import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import { AuthenticationContext } from 'context/AuthenticationContext';
import PrivateRoute from 'components/PrivateRoute';
import APP_ROUTES, {
  ADMIN_ROUTES,
  BROADCAST_ROUTES,
  LIBRARY_ROUTES,
  REPORT_ROUTES,
  EVENTS_ROUTES,
} from 'routes/app';
import { MusicSlideOverContext } from 'context/MusicSlideOverContext';
import { PageTitleContext } from 'context/PageTitleContext';
import { MusicPlayerContext, PlayerProperties } from 'context/MusicPlayer';
import { CrumbsContext } from 'context/CrumbsContext';
import PageView from 'components/PageView';
import Notification from 'components/Notification/notification';
import { NotificationContext } from 'context/NotificationContext';
import { UserSlideOverContext } from 'context/UserSlideOverContext';
import { LibrarySlideOverContext } from 'context/LibrarySlideOverContext';
import { XIcon } from '@heroicons/react/outline';

export default function App() {
  const [user, setUser] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [libraryItem, setLibraryItem] = useState({});
  const [music, setMusic] = useState({});
  const [title, setTitle] = useState('');
  const [crumbs, setCrumbs] = useState([]);
  const [notification, setNotification] = useState({});
  const [playing, setPlaying] = useState(PlayerProperties);

  let history = useHistory();

  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Check if the screen is less than 960px
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 960);
    };

    // Check on initial load
    handleResize();

    // Add resize listener
    window.addEventListener('resize', handleResize);

    // Cleanup listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

 // Show the toast only on small screens
 useEffect(() => {
  if (isSmallScreen) {
    toast.custom((t) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#2d3748',
          color: 'white',
          padding: '12px 16px',
          borderRadius: '8px',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
          width: '100%',
          maxWidth: '500px',
        }}
      >
        <span>💻 For optimal results, use this app on a desktop.</span>
        <button
          onClick={() => toast.dismiss(t.id)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <XIcon className="h-5 w-5 text-white" />
        </button>
      </div>
    ), {
      position: 'top-center',
      duration: Infinity,
    });
  }
}, [isSmallScreen]);


  return (
    <>
      <Router history={history}>
        <AuthenticationContext.Provider value={{ user, setUser }}>
          <MusicPlayerContext.Provider value={{ playing, setPlaying }}>
            <LibrarySlideOverContext.Provider
              value={{ libraryItem, setLibraryItem }}
            >
              <UserSlideOverContext.Provider
                value={{ userDetails, setUserDetails }}
              >
                <MusicSlideOverContext.Provider value={{ music, setMusic }}>
                  <CrumbsContext.Provider value={{ crumbs, setCrumbs }}>
                    <PageTitleContext.Provider value={{ title, setTitle }}>
                      <NotificationContext.Provider
                        value={{ notification, setNotification }}
                      >
                        <Notification />
                        <PageView />
                        <Toaster /> {/* Add Toaster for the toast container */}
                        <Switch>
                          {APP_ROUTES.concat(BROADCAST_ROUTES)
                            .concat(LIBRARY_ROUTES)
                            .concat(REPORT_ROUTES)
                            .concat(ADMIN_ROUTES)
                            .concat(EVENTS_ROUTES)
                            .map((route, index) => {
                              return route.private ? (
                                <PrivateRoute
                                  key={index}
                                  exact={route.exact}
                                  path={route.link}
                                  component={route.page}
                                />
                              ) : (
                                <Route
                                  key={index}
                                  exact={route.exact}
                                  path={route.link}
                                  component={route.page}
                                />
                              );
                            })}
                        </Switch>
                      </NotificationContext.Provider>
                    </PageTitleContext.Provider>
                  </CrumbsContext.Provider>
                </MusicSlideOverContext.Provider>
              </UserSlideOverContext.Provider>
            </LibrarySlideOverContext.Provider>
          </MusicPlayerContext.Provider>
        </AuthenticationContext.Provider>
      </Router>
    </>
  );
}
